import { Box, Typography, Card, Stack, CardContent } from '@mui/material'
import { Button } from '@mui/material'
import { ArrowLeftIcon } from '@heroicons/react/24/outline'
import { useNavigate } from 'react-router-dom'
import { TIME_PERIOD_NAMES, TimePeriod } from '../../types'

interface Props {
  isTestMode?: boolean
  timePeriod: TimePeriod
  backPage?: string
}

/**
 * Header component for game pages that displays navigation and time period information.
 * Shows a back button and the selected time period for the current game.
 */
const GameInfo = ({ isTestMode = false, timePeriod, backPage = '/' }: Props) => {
  const navigate = useNavigate()

  return (
    <Card sx={{ minHeight: '150px' }}>
      <CardContent sx={{ py: 2 }}>
        <Stack spacing={2}>
          {/* Navigation and Title */}
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Button
              onClick={() => navigate(backPage)}
              variant="outlined"
              size="small"
              startIcon={<ArrowLeftIcon className="w-4 h-4" />}
              sx={{ textTransform: 'none' }}
            >
              Back
            </Button>
            <Typography variant="h6" component="h1" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
              Newswordy
            </Typography>
          </Box>

          {/* Time Period Info */}
          <Box
            sx={{
              p: 1.5,
              bgcolor: 'grey.50',
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'grey.200',
            }}
          >
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
              Selected Time Period
            </Typography>
            <Typography variant="body1" sx={{ fontWeight: 'semibold', color: 'text.primary' }}>
              {isTestMode ? 'September 2nd - September 8th' : TIME_PERIOD_NAMES[timePeriod]}
            </Typography>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  )
}

export default GameInfo
